import { render, staticRenderFns } from "./AlertRed.vue?vue&type=template&id=e195ade0"
import script from "./AlertRed.vue?vue&type=script&lang=js"
export * from "./AlertRed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports